export const TimeFormat = 'HH:mm';  //24 hour format
export const TimeFormatWithSeconds = 'HH:mm:ss';  //24 hour format

export const DateTimeFormatTZ = 'YYYY-MM-DDTHH:mm:ssZ'; //YYYY-MM-DDTHH:mm:ssZ